export default {"src":"/_next/static/media/setting.94b7eb63.svg","height":41,"width":41};